/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanResponse } from '../models/BooleanResponse';
import type { CreateDrugCatalogCommand } from '../models/CreateDrugCatalogCommand';
import type { CreateDrugStrengthCommand } from '../models/CreateDrugStrengthCommand';
import type { DrugCatalogDtoListResponse } from '../models/DrugCatalogDtoListResponse';
import type { DrugCatalogDtoResponse } from '../models/DrugCatalogDtoResponse';
import type { DrugStrengthDtoResponse } from '../models/DrugStrengthDtoResponse';
import type { UpdateDrugCatalogCommand } from '../models/UpdateDrugCatalogCommand';
import type { UpdateDrugStrengthCommand } from '../models/UpdateDrugStrengthCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugCatalogService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns DrugCatalogDtoListResponse Success
     * @throws ApiError
     */
    public getApiDrugCatalogDrugCatalog(): CancelablePromise<DrugCatalogDtoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugCatalog/DrugCatalog',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugCatalogDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugCatalogCreateDrugCatalog(
        requestBody?: CreateDrugCatalogCommand,
    ): CancelablePromise<DrugCatalogDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugCatalog/CreateDrugCatalog',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugCatalogDtoResponse Success
     * @throws ApiError
     */
    public putApiDrugCatalogUpdateDrugCatalog(
        requestBody?: UpdateDrugCatalogCommand,
    ): CancelablePromise<DrugCatalogDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/DrugCatalog/UpdateDrugCatalog',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param drugId
     * @returns BooleanResponse Success
     * @throws ApiError
     */
    public deleteApiDrugCatalogDeleteDrugCatalog(
        drugId: string,
    ): CancelablePromise<BooleanResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/DrugCatalog/DeleteDrugCatalog/{drugId}',
            path: {
                'drugId': drugId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugStrengthDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugCatalogCreateDrugStrength(
        requestBody?: CreateDrugStrengthCommand,
    ): CancelablePromise<DrugStrengthDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugCatalog/CreateDrugStrength',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugStrengthDtoResponse Success
     * @throws ApiError
     */
    public putApiDrugCatalogUpdateDrugStrength(
        requestBody?: UpdateDrugStrengthCommand,
    ): CancelablePromise<DrugStrengthDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/DrugCatalog/UpdateDrugStrength',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param strengthId
     * @returns BooleanResponse Success
     * @throws ApiError
     */
    public deleteApiDrugCatalogDeleteDrugStrength(
        strengthId: string,
    ): CancelablePromise<BooleanResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/DrugCatalog/DeleteDrugStrength/{strengthId}',
            path: {
                'strengthId': strengthId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
